import Empresa from "../../model/admin/Empresa";
const apiUrl = process.env.REACT_APP_API_URL;

export const PostEmpresa = async (page: string, empresa : Empresa, id_usu_log : string) => {
    try{
        const response = await fetch(`${apiUrl}:8074/admin/empresas/${id_usu_log}`,{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(empresa)
        });

        if (response.ok){
            const jsonData = await response.json();
            return jsonData;
        }else {
            alert(await response.text());
        }
    } catch(error){
        console.log('Error al obter los datos', error);
    }
};